const BACKEND = 'https://yekasas.com:8444'
//$
const CURRENCY = 'S/ '
const CURRENCY_MODE = 'PEN'
const imageTypes = ['image/jpeg', 'image/pjpeg', 'image/png', 'image/gif', 'image/webp', 'image/vnd.microsoft.icon']
const videoTypes = ['video/mp4', 'video/webm', 'video/avi', 'video/msvideo', 'video/x-msvideo', 'video/mpeg', 'video/3gpp', 'video/quicktime']
const fileExt = /(?:\.([^.]+))?$/

export { BACKEND, imageTypes, videoTypes, fileExt, CURRENCY, CURRENCY_MODE };
